// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zydSetDiscount .rule_home__search[data-v-7efcd051] {\n  background: #FFF;\n  padding: 0.625rem;\n}\n.zydSetDiscount .text[data-v-7efcd051] {\n  color: #409eff;\n  cursor: pointer;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
